export default __webpack_public_path__ + "static/media/regulatory--one-way-right--g2.8585b78c.png";